module.exports = __webpack_public_path__ + "img/magnifying-glass.eb6f73f6.png";